export default "__VITE_ASSET__CTf$e5Fr__"